import React, { createContext, useContext, useState } from "react";

const CompletedTasksContext = createContext(undefined);
export const CompletedTasksProvider = ({
  children,
}) => {
    const [completedTasks, setCompletedTasks] = useState([]);
    const [completedTaskDetailsData, setCompletedTaskDetailsData] = useState(null);
    return (
        <CompletedTasksContext.Provider
        value={{
            completedTasks,
            setCompletedTasks,
            completedTaskDetailsData,
            setCompletedTaskDetailsData
        }}
        >
            {children}
        </CompletedTasksContext.Provider>
    );
};
export const useCompletedTasksContext = () => {
  const context = useContext(CompletedTasksContext);
  if (!context) {
    throw new Error("useCompletedTasksContext must be used within a CompletedTasksProvider");
  }
  return context;
};